const topics = [
  { name: '韩漫推荐', heat: '热', heatColor: 'text-accent-500', icon: 'ri-fire-line' },
  { name: '日漫大全', heat: '热', heatColor: 'text-accent-500', icon: 'ri-fire-line' },
  { name: '国漫排行榜', heat: '新', heatColor: 'text-primary-500', icon: 'ri-sparkling-line' },
  { name: '漫画分类', heat: '热', heatColor: 'text-accent-500', icon: 'ri-fire-line' },
  { name: '好看的漫画', heat: '热', heatColor: 'text-accent-500', icon: 'ri-fire-line' },
  { name: '热血战斗', heat: '荐', heatColor: 'text-secondary-600', icon: 'ri-thumb-up-line' },
  { name: '甜蜜恋爱', heat: '荐', heatColor: 'text-secondary-600', icon: 'ri-thumb-up-line' },
  { name: '悬疑推理', heat: '新', heatColor: 'text-primary-500', icon: 'ri-sparkling-line' },
  { name: '每日更新', heat: '热', heatColor: 'text-accent-500', icon: 'ri-fire-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            大家都在讨论的<strong>漫画分类</strong>话题，发现最热<strong>韩漫推荐</strong>与<strong>国漫排行榜</strong>动态
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-[900px] mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-full hover:border-primary-200/60 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <span className={`text-sm ${topic.heatColor}`}>
                <i className={`${topic.icon} text-sm`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className={`text-xs font-medium px-1.5 py-0.5 rounded ${topic.heat === '热' ? 'bg-accent-100/70 text-accent-600' : topic.heat === '新' ? 'bg-primary-100/70 text-primary-600' : 'bg-secondary-100/70 text-secondary-600'}`}>
                {topic.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}